import(/* webpackMode: "eager" */ "/app/webapp/app/pwa/(simple-layout)/error.tsx");
